import { render } from "./OrderTransportComponent.vue?vue&type=template&id=662f4100&scoped=true"
import script from "./OrderTransportComponent.vue?vue&type=script&lang=js"
export * from "./OrderTransportComponent.vue?vue&type=script&lang=js"

import "./OrderTransportComponent.vue?vue&type=style&index=0&id=662f4100&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662f4100"]])

export default __exports__